import { render, staticRenderFns } from "./merge-pick-modal.vue?vue&type=template&id=8dd36858&scoped=true"
import script from "./merge-pick-modal.vue?vue&type=script&lang=js"
export * from "./merge-pick-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd36858",
  null
  
)

export default component.exports